module.exports = __webpack_public_path__ + "images/addImg@3x.svg";